export const NOTIFICATION_SUCCESS = 'NOTIFICATION_SUCCESS';
export const NOTIFICATION_WARNING = 'NOTIFICATION_WARNING';
export const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR';
export const NOTIFICATION_INFO = 'NOTIFICATION_INFO';
export const PERSISTENT_NOTIFICATION_SUCCESS =
  'PERSISTENT_NOTIFICATION_SUCCESS';
export const PERSISTENT_NOTIFICATION_WARNING =
  'PERSISTENT_NOTIFICATION_WARNING';
export const PERSISTENT_NOTIFICATION_ERROR = 'PERSISTENT_NOTIFICATION_ERROR';
export const PERSISTENT_NOTIFICATION_INFO = 'PERSISTENT_NOTIFICATION_INFO';
export const NOTIFICATION_RESET = 'NOTIFICATION_RESET';
export const NOTIFICATION_CLICKED = 'NOTIFICATION_CLICKED';
export const NOTIFICATION_RESETED = 'NOTIFICATION_RESETED';
